import React from 'react'
import { FieldControl, IconControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { getOperatorsByType, getValueMetadata } from './filterUtils';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

const FilterRow = ({ filter, selectedColumn, format, index, filterableColumns, filtersLength }) => {
    const { visualObject, setVisualObject } = useVisualFormContext();

    const filterableColumnsObject = filterableColumns?.map(filter => ({
        Text: filter.DisplayName,
        Value: filter.FieldName,
    }));

    const hasOneFilter = filtersLength === 1;
    const hasMaxFilters = filtersLength > 2;

    const addFilterRow = () => {
        setFilters(prev => [...prev, {}]);
    };

    const deleteFilterRow = (indexToRemove) => {
        setFilters(prev => {
            const updated = prev.filter((_, index) => index !== indexToRemove);
            return hasOneFilter ? [...updated, {}] : updated;
        });
    };

    const updateFilter = (index, updatedFields) => {
        setFilters(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                ...updatedFields
            };
            return updated;
        });
    };

    const setFilters = (updater) => {
        const current = visualObject?.Filters || [];
        const updated = updater(current);
        setVisualObject(prev => ({
            ...prev,
            Filters: updated.length > 0 ? updated : [{}]
        }));
    };

    return (
        <div key={`vcs-filter-${index}`} className={"dashboard-filter-row"} >
            <div className="filter-text">
                {index === 0 ? "If" : 'And'}
            </div>
            <div className="field-container">
                <FieldControl
                    fieldMetadata={{
                        FieldType: SystemTypes.UIFieldType.SelectList,
                        FieldName: "Column",
                        DataJson: filterableColumnsObject
                    }}
                    groupId={"visual"}
                    value={filter?.FieldName}
                    onChange={v => {
                        updateFilter(index, {
                            FieldName: v,
                            Operator: null,
                            Value: null
                        });
                    }}
                />
                <FieldControl
                    fieldMetadata={{
                        FieldType: SystemTypes.UIFieldType.SelectList,
                        FieldName: "Operator",
                        DataJson: getOperatorsByType(format)
                    }}
                    disabled={!selectedColumn}
                    groupId={"visual"}
                    value={filter?.Operator}
                    onChange={v => {
                        updateFilter(index, {
                           Operator: v
                        });
                    }}
                />
                <FieldControl
                    fieldMetadata={getValueMetadata(format)}
                    groupId={"visual"}
                    value={filter?.Value}
                    disabled={!selectedColumn}
                    onChange={v => {
                        updateFilter(index, {
                            Value: v
                        });
                    }}
                />
            </div>
            <div className="button-container">
                <IconControl iconKey={"delete"}
                    onClick={() => deleteFilterRow(index)} />
                <IconControl iconKey={"add"}
                    className={hasMaxFilters ? "disabled" : null}
                    onClick={!hasMaxFilters ? addFilterRow : null} />
            </div>
        </div >
    )
}

export default FilterRow